module.exports = __webpack_public_path__ + "static/media/sidney.ad12657c.jpeg";